var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dynamicRoute",attrs:{"id":"dynamicRoute"}},[_c('div',{staticClass:"psPatientsList"},[_c('ps-upper-bar',{attrs:{"site":{ site: 'Pacientes' },"newButton":true,"tooltip":'Nuevo paciente'},on:{"newItem":_vm.newPatient}}),_c('div',{staticClass:"row"},[_c('ps-patients-list-search-bar')],1),_c('ps-patients-list-table')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }